import React, { useEffect, useState } from "react";
import "./Header.scss";
import logo from "../../assets/homePage/logoo.png";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./../../redux/actions/cartActions";
import { newcolor, borderwhite, borderblack } from "./../../constants/color";
import OfferCard from "../OfferCard/OfferCard";

const Header = () => {
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");
  const raerAcess = localStorage.getItem("raerAcess");

  const navigate = useNavigate();
  const [category, setCategory] = useState([]);

  const cartDetails = useSelector((state) => state.cart);

  console.log(cartDetails);
  const { cartItems } = cartDetails;

  console.log(cartItems);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [cartProduct, setCartProduct] = useState([]);

  const [topOffer, setTopOffer] = [
    {
      offer: "10% OFF",
      code: "FIRST10",
      details: "Get 10% off on your first purchase above Rs. 999",
    },
  ];
  //done
  const getCartProductDetails = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getProductsInCart/${userId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data?.products);
        if (response?.data?.status == true) {
          const cartData = response?.data?.data?.products;
          console.log(cartData);
          cartData.map((item) => {
            console.log(typeof item?.sku);
            if (item) dispatch(addToCart(item?.sku));
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getCartProductDetails();
  }, []);

  const dispatch = useDispatch();

  const handleCategorySelect = (categoryId) => {
    setSearchTerm(""); // Clear search term after selection
    navigate(`/shop/${categoryId}`);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter categories based on search term
  const filteredCategories = category.filter((cat) =>
    cat.categoryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const categoryOptions = filteredCategories.map((cat, index) => (
    <option key={index} value={cat._id}>
      {cat.categoryName}
    </option>
  ));

  const getAllCategory = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + "category/getAllCategories",
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          setCategory(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const onLogOut = () => {
    console.log(userId);

    const config = {
      url: process.env.REACT_APP_BASE_URL + "auth/logout",
      method: "post",
      data: {
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          localStorage.clear();
          navigate("/");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  // fot the cart super
  // const totalItems =.reduce((acc, item) => acc + item.quantity, 0);
  return (
    <>
      <div className="header-main">
        <nav
          class="navbar fixed-top navbar-expand-xl shadow"
          style={{
            //  background: "#E5E2DC",
            background: newcolor.background,
            borderBottom: "1px solid #806040",
            // borderBottom: "1px solid white",
            // boxShadow: "0px 0px 4px black",
            color: newcolor.color,
          }}
        >
          <div class="container">
            {/* Navbar Logo */}
            <a class="navbar-brand" href="/">
              <div className="outline shadow"></div>
              <img
                src={logo}
                alt=""
                width="80"
                height="60"
                class="d-inline-block align-text-top"
              />
            </a>

            {/* offer card */}
            <div className="offer-card">
              <OfferCard
                offer={topOffer.offer}
                code={topOffer.code}
                details={topOffer.details}
              />
            </div>

            <div className="btn-outerdiv">
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                {/* <span
                  class="navbar-toggler-icon"
                  style={{ color: newcolor.color }}
                ></span> */}
                <i
                  class="bi bi-list fs-1"
                  style={{ color: newcolor.color }}
                ></i>
              </button>

              {/* cart  */}
              <li className="nav-item-cat cart-circle">
                <a
                  class="nav-link fs-5"
                  href="/cart"
                  onClick={() => {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  <i class="bi bi-cart2"></i>
                  <span
                    className="suptag"
                    style={{
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      fontSize: ".7rem",
                      width: "15px",
                      height: "15px",
                      position: "absolute",
                      top: "8px",
                      right: "7px",
                    }}
                  >
                    {cartItems.length}
                  </span>
                </a>
              </li>
            </div>

            <div
              class="collapse navbar-collapse justify-content-end"
              id="navbarTogglerDemo02"
            >
              {/* Navbar Pages */}
              <ul className="navbar-nav gap-3 me-3 mb-2 mb-lg-0">
                <li
                  class="nav-item "
                  className="text"
                  style={{ fontWeight: "600" }}
                >
                  <a
                    class="nav-link"
                    activeClassName="active"
                    aria-current="page"
                    href="/"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Home
                  </a>
                </li>

                <li
                  class="nav-item"
                  className="text"
                  style={{
                    fontWeight: "600",
                  }}
                >
                  <a
                    class="nav-link"
                    href="/allProduct"
                    activeClassName="active"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Shop
                  </a>
                </li>
                <li
                  class="nav-item"
                  className="text"
                  style={{ fontWeight: "600" }}
                >
                  <a
                    class="nav-link "
                    href="/about"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    About Us
                  </a>
                </li>
                <li
                  class="nav-item"
                  className="text"
                  style={{ fontWeight: "600" }}
                >
                  <a
                    class="nav-link "
                    href="/contact"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>

              {/* Search bar */}
              {/* <form class="d-flex">
                <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
                <button class="btn btn-outline-success" type="submit"><i class="bi bi-search"></i></button>
              </form> */}

              {/* Navbar Icons */}
              <ul class="navbar-nav mb-lg-0 mt-2">
                <li
                  className="nav-item-1 d-flex rounded-0"
                  style={{ position: "relative" }}
                  onMouseLeave={() => setSearchTerm("")}
                >
                  <a
                    className="nav-link fs-6 "
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    onMouseLeave={() => setSearchTerm("")}
                  >
                    <i className="bi bi-search text-black"></i>
                  </a>
                  <input
                    type="text"
                    placeholder="Search"
                    className="search-input"
                    style={{
                      border: "none",
                      outline: "none",
                      borderRadius: "22px",
                    }}
                    value={searchTerm}
                    onChange={handleInputChange} // Update searchTerm on input change
                  />

                  {/* Relative search list */}
                  {searchTerm && (
                    <ul
                      className="search-results"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid #ccc",
                        zIndex: 1000,
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        lineHeight: "10px",
                        maxHeight: "200px",
                        borderEndStartRadius: "5px",
                        borderEndEndRadius: "5px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredCategories.map((cat, index) => (
                        <li
                          id="hover"
                          key={index}
                          onClick={() => handleCategorySelect(cat._id)}
                          style={{
                            padding: "10px",
                            cursor: "pointer",
                          }}
                          // onMouseOver={{ background: "red" }}
                        >
                          {cat.categoryName}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>

                <span className="span mx-3">
                  {/* account */}
                  <li class="nav-item">
                    <a
                      class="nav-link fs-5"
                      href="/myaccount"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <i class="bi bi-person"></i>
                    </a>
                  </li>

                  {/* wishlist */}
                  <li class="nav-item">
                    <a
                      class="nav-link fs-5"
                      href="/wishlist"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <i class="bi bi-heart"></i>
                    </a>
                  </li>

                  {/* cart */}
                  <li class="nav-item cart-circle" id="cart">
                    <a
                      class="nav-link fs-5"
                      href="/cart"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <i class="bi bi-cart2 text-black "></i>
                      <span
                        className="sup"
                        style={{
                          background: "red",
                          color: "white",
                          borderRadius: "50%",
                          fontSize: ".8rem",
                          width: "14px",
                          height: "14px",
                          position: "absolute",
                          top: "6px",
                          right: "6px",
                        }}
                      >
                        {cartItems.length}
                      </span>
                    </a>
                  </li>
                </span>
              </ul>

              {raerAcess == "1" && (
                <button
                  class="text-light px-3 py-2 rounded-1"
                  id="btnnn"
                  onClick={() => {
                    navigate("/dashboard");
                    window.scrollTo(0, 0);
                  }}
                  style={{
                    ...borderwhite,
                    backgroundColor: newcolor.background,
                    fontSize: "18px",
                    fontWeight: "600",
                    // padding:"11px"
                  }}
                >
                  Dashboard
                </button>
              )}

              {!userId ? (
                <button
                  class="text-light px-3 py-2 rounded-1"
                  id="btnnn"
                  onClick={() => {
                    navigate("/login");
                    window.scrollTo(0, 0);
                  }}
                  style={{
                    ...borderwhite,
                    backgroundColor: newcolor.background,
                    fontSize: "18px",
                    fontWeight: "600",
                    // padding:"11px"
                  }}
                >
                  Login/Signup
                </button>
              ) : (
                ""
                // <button
                //   class="text-light px-3 py-2 rounded-1"
                //   onClick={onLogOut}
                //   style={{
                //     backgroundColor: "#b29d88",
                //     border: "none",
                //     fontSize: "18px",
                //     fontWeight: "600",
                //     // padding:"11px"
                //   }}
                // >
                //   Logout
                // </button>
              )}
            </div>
          </div>
        </nav>

        <ToastContainer />
      </div>
    </>
  );
};

export default Header;
